import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { BackHeader, PageTemplate } from '@_widgets/common';
import { announcementApi, announcementModel } from '@_entities/system';

import { userApi } from '@_entities/user';
import { useHTMLParse } from '@_shared/hooks';
import { SkeletonUI } from '@_shared/ui';
import { Typography } from '@_shared/ui/Typography';

import { replaceNickname } from './AnnouncementDetailPage.logic';
import * as S from './AnnouncementDetailPage.style';

export function AnnouncementDetailPage() {
	const { id } = useParams();
	const [data, setData] = useState<announcementModel.IAnnouncement>();
	const [nickname, setNickname] = useState<string>();

	const parsedContent = useHTMLParse(replaceNickname(data?.content ?? '', nickname as string));

	useEffect(() => {
		(async () => {
			const { data: announcementResponseData } = await announcementApi.getAnnouncement(
				id as string,
			);
			const { data: userResponseData } = await userApi.getUser();

			setData({
				...announcementResponseData,
			});
			setNickname(userResponseData.nickname);
		})();
	}, []);

	return (
		<PageTemplate header={<BackHeader>공지사항</BackHeader>} nav={false}>
			{/* Skeleton UI */}
			{data === undefined ? (
				<>
					<S.AnnouncementTitle>
						<SkeletonUI width="80%" height="24px" borderRadius="8px" />
						<SkeletonUI width="80px" height="24px" borderRadius="8px" />
					</S.AnnouncementTitle>
				</>
			) : (
				<>
					<S.AnnouncementTitle>
						<Typography type="title-medium" color="font-primary">
							{data.title}
						</Typography>
						<Typography type="label-large" color="font-tertiary">
							{data.createdDate}
						</Typography>
					</S.AnnouncementTitle>

					<S.AnnouncementContent>
						<Typography type="body-medium" color="font-primary" noOfLine={-1}>
							{parsedContent}
						</Typography>
					</S.AnnouncementContent>
				</>
			)}
		</PageTemplate>
	);
}
